(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const headers = document.querySelectorAll('.cn_custom_details_accordian .cn_custom_accordion-item-header');

    const firstHeader = headers[0];
    const firstBody = firstHeader.nextElementSibling;

    // open first accordian on page load
    // firstHeader.classList.add('active');
    // firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
    // open first accordian on page load

    headers.forEach((header) => {
      header.addEventListener('click', () => {
        const isActive = header.classList.contains('active');

        // dont allow to close all accordians
        // if (isActive) {
        //   return;
        // }
        // dont allow to close all accordians

        headers.forEach((item) => {
          item.classList.remove('active');
          item.nextElementSibling.style.maxHeight = '0px';
        });

        if (!isActive) {
          header.classList.add('active');
          const body = header.nextElementSibling;
          body.style.maxHeight = body.scrollHeight + 'px';
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
